// Release version and build time, injected at build time by vite.config.ts
// (buildInfo.ts): the root VERSION file, or the VERSION build arg in CI.
declare const __APP_VERSION__: string
declare const __BUILD_DATE__: string

export const APP_VERSION: string = __APP_VERSION__
export const BUILD_DATE: string = __BUILD_DATE__
